import { createSelector } from 'reselect';

// formHistory selectors
export const getFormHistory = state => state.cards.formHistory;

// customizationBar selectors
export const getAddressingOptionStatus = state => state.cards.cardCustomizationBar.hasRecipientAddressing;
export const getCustomizationErrorsByElementUUID = state => state.cards.cardCustomizationBar.errorsByElementUUID;

export const getCustomizationHasErrors = createSelector(
  getCustomizationErrorsByElementUUID,
  (errorsByElementUUID) => {
    if (errorsByElementUUID && errorsByElementUUID.length > 0) {
      return true;
    }
    return false;
  }
);

// recipients selectors
export const getSelectedGuestIds = state => state.cards.recipients.selectedGuestIds;
export const getInvitedGuestsCount = state => state.guestList.guests.orderedIds.length || 0;



// WEBPACK FOOTER //
// ./src/cards/selectors/Customization.js